<template>
  <div class="ma-4 pa-4" style="background-color: #fff; min-height: calc(100vh - 100px);">
    <h1>Sidasi</h1>
  </div>
</template>

<script>
export default {
  name: 'Sidasi'
}
</script>